import { render } from "./SplashScreen.vue?vue&type=template&id=2cb3c36a"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
script.render = render

export default script